import ProviderFactory from "../core/ProviderFactory";
import OcontentMiscProvider from "../core/providers/ocontent/OcontentMiscProvider";
import {
  Leaderboard,
  LeaderboardUser,
  LeaderboardUserLevel,
} from "../core/types/Leaderboard";
import {
  OcontentProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";
export default abstract class LeaderboardModel {
  static leaderboardCache: Array<Leaderboard> = [];
  private static miscProvider: OcontentMiscProvider = ProviderFactory.create(
    OcontentProviderType.Misc,
    ProviderConfiguration.ocontent
  );

  public static async getLeaderboardPerLevel(): Promise<Array<Leaderboard> | null> {
    try {
      if (LeaderboardModel.leaderboardCache.length === 0) {
        const data = await LeaderboardModel.getLeaderboardData();
        if (data === null) {
          throw "Leaderboard json not found";
        }
        const levels: unknown = {};
        for (const type in LeaderboardUserLevel) {
          // @ts-ignore
          levels[type] = [];
        }

        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          // @ts-ignore
          levels[item.level].push(item);
        }

        const dataPerLevel: Leaderboard[] = [];
        //@ts-ignore
        for (const level in levels) {
          //@ts-ignore
          const actualLevel = levels[level];
          if (actualLevel.length > 0) {
            dataPerLevel.push({
              // @ts-ignore
              type: LeaderboardUserLevel[level],
              items: actualLevel,
            });
          }
        }

        LeaderboardModel.leaderboardCache = dataPerLevel.reverse();
      }

      return LeaderboardModel.leaderboardCache;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  public static async getLeaderboardData(): Promise<Array<LeaderboardUser> | null> {
    try {
      const leadJson = await LeaderboardModel.miscProvider.getLeaderboard();
      return leadJson;
    } catch (err) {
      console.error(err);

      return null;
    }
  }
}
